import { AlertTriangle } from "lucide-react";

const GapsTab = ({ gapsData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Gap Register</h3>
                <p className="text-sm text-slate-500 mt-1">Identified compliance deficiencies requiring remediation.</p>
              </div>
            <div className="grid grid-cols-1 gap-4">
              {gapsData.map((gap) => (
                <div key={gap.id} className="p-6 bg-white ring-1 ring-rose-200 rounded-2xl shadow-sm relative overflow-hidden hover:shadow-md transition-all group flex flex-col md:flex-row gap-6 items-start">
                  <div className="absolute top-0 left-0 w-1.5 h-full bg-rose-500"></div>
                  
                  <div className="p-4 rounded-2xl shrink-0 bg-rose-50 text-rose-600 ring-1 ring-rose-100 group-hover:bg-rose-500 group-hover:text-white transition-colors">
                    <AlertTriangle size={24} strokeWidth={2} />
                  </div>
                  
                  <div className="flex-1 space-y-3">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                       <div className="flex items-center gap-2">
                         <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-2 py-1 rounded-md tracking-widest">{gap.id}</span>
                         <span className="text-xs font-bold text-indigo-700 bg-indigo-50 px-2.5 py-1 rounded-md ring-1 ring-indigo-200/50">Control: {gap.control}</span>
                       </div>
                       <span className="px-3 py-1.5 rounded-full ring-1 bg-rose-50 text-rose-700 ring-rose-200/60 text-[10px] font-bold uppercase tracking-widest">
                          {gap.severity} Severity
                       </span>
                    </div>
                    
                    <div>
                       <h4 className="text-lg font-bold text-slate-900 mb-1.5">{gap.title}</h4>
                       <p className="text-sm font-medium text-slate-600 leading-relaxed">{gap.description}</p>
                    </div>

                    <div className="pt-3 flex items-center gap-3">
                      <span className="bg-slate-50 text-slate-600 px-3 py-1.5 rounded-lg ring-1 ring-slate-200/50 text-xs font-bold flex items-center gap-1.5">
                         Status: <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span> {gap.status}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default GapsTab;